import { Text, LinkButton, Tooltip } from '$components'
import { DogIcon, PlusIcon } from '$components'
import { PetRoutePaths } from '../routes/protected'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { SUBSCRIPTION_EXPIRED_MESSAGE } from '$constants/subscription'

export type NoPetsEmptyStateProps = {
  isNoResults: boolean
}

export function NoPetsEmptyState({ isNoResults = false }: NoPetsEmptyStateProps) {
  const { hasSubscriptionExpired } = useTenant()

  return (
    <div className="w-full h-fit p-12 bg-neutral-50 rounded-3xl flex flex-col items-center justify-center text-center">
      <DogIcon className="size-12 text-indigo-500 mb-4" />

      <Text
        type="h3"
        className="mb-4 text-gray-900"
      >
        {!isNoResults ? 'No pets created yet' : 'No pets found'}
      </Text>

      <Text
        type="s"
        className="text-gray-600 max-w-md mb-6"
      >
        {!isNoResults
          ? 'Start by adding pets to manage their appointments, medical records, and treatment history. Each pet will be linked to their owner.'
          : 'No pets found matching your search. Try adjusting your search criteria or create a new pet.'
        }
      </Text>

      {isNoResults && (
        <Tooltip
          content={hasSubscriptionExpired ? SUBSCRIPTION_EXPIRED_MESSAGE : undefined}
          disabled={!hasSubscriptionExpired}
        >
          <LinkButton
            to={PetRoutePaths.PetsCreate}
            icon={PlusIcon}
            disabled={hasSubscriptionExpired}
          >
            New Pet
          </LinkButton>
        </Tooltip>
      )}
    </div>
  )
}
